import request from './request'

export function advert(query) {
    return request({
        url:'/huhucount/index/advert',
        method: 'post',
        data: query
    });
}

export function getYearAccount(query) {
    return request({
        url:'/huhucount/year/getYearAccount',
        method: 'post',
        data: query
    });
}

export function getAlbum(query) {
    return request({
        url:'/huhucount/year/getAlbum',
        method: 'post',
        data: query
    });
}

export function addFavorite(query) {
    return request({
        url:'/huhucount/year/addFavorite',
        method: 'post',
        data: query
    });
}
